export * from './identifierDumbTable.component';